import { connect } from 'react-redux';
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import { convertDate } from '../../../utils';
import { filterPlansMobile } from '../../../actions/searchActions';
import { getDestinations } from '../../../actions/globalActions';

class InfosMobile extends Component {
  render() {
    if (!this.props.destinations.length) {
      return null;
    }

    const destinationFiltered =  this.props.destinations && this.props.destinations.filter((dest) => dest.slug === this.props.match.params.destination);
    const destination = destinationFiltered && destinationFiltered.length ? destinationFiltered[0].name : "";

    return (
      <section
        className="info-resultado-mobile flex component"
        onClick={() => !this.props.searchState && this.props.filterPlansMobile()}
      >
        <ul>
          <li className="texto-info-mobile">Você pesquisou por:</li>
          <li className="destino-info-mobile">
            Destino: <b>{destination}</b>
          </li>
          <li className="date-info-mobile">
            {convertDate(this.props.match.params.begin_date)} - {convertDate(this.props.match.params.end_date)}
          </li>
        </ul>
        <button onClick={() => this.props.searchState && this.props.filterPlansMobile()}>
          {!this.props.searchState ? (
            <img alt="pesquisar" src="/assets/images/search.svg" />
          ) : (
            <img alt="pesquisar" src="/assets/images/quit.svg" />
          )}
        </button>
      </section>
    );
  }
}

export default withRouter(
  connect(
    (state) => ({
      searchState: state.search.searchState,
      mobile: state.mobile.mobileActive,
      destinations: state.global.destinations,
    }),
    {
      filterPlansMobile,
      getDestinations,
    }
  )(InfosMobile)
);



// WEBPACK FOOTER //
// ./src/components/search/infos_mobile/InfosMobile.jsx